import { render } from "./SelectedSection.vue?vue&type=template&id=cbf63d08&scoped=true"
import script from "./SelectedSection.vue?vue&type=script&lang=js"
export * from "./SelectedSection.vue?vue&type=script&lang=js"

import "./SelectedSection.vue?vue&type=style&index=0&id=cbf63d08&lang=scss"
import "./SelectedSection.vue?vue&type=style&index=1&id=cbf63d08&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf63d08"]])

export default __exports__